<template>
  <div>
    <el-row style="margin-bottom: 25px" v-if="showPagination">
      <div style="padding-top:15px">
        <el-row class="func-55-item" :style="`${estiloLinha}; border-radius: 10px`">
          <el-col :span="8" class="text-right">
            <el-button
              type="text"
              :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}!important`"
              @click="getMonthHistory(prev)"
            >
              <i class="el-icon-arrow-left"></i>
            </el-button>
          </el-col>
          <el-col :span="8" class="text-center">
            <h2
              class="func-55-title-headers"
              :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}; margin-top:2px;`"
            >
              <template v-if="monthsPerPage>1">
                {{ pagination.startLabel }} / {{ pagination.endLabel }}
              </template>
              <template v-else>
                {{ pagination.startLabel }}
              </template>
            </h2>
          </el-col>
          <el-col :span="8">
            <el-button
              type="text"
              :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}!important`"
              :disabled="lastMonthGreaterThanCurrent"
              @click="getMonthHistory(next)"
            >
              <i class="el-icon-arrow-right" style="font-size: 16px; font-weight: bold;"></i>
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-row>
    <el-row v-if="showBody">
      <ul class="func-listagens">
        <li
          v-for="(item, index) in history"
          :key="index"
          :name="index"
          :style="`${estiloLinha}`"
          @click="$emit('selectedItem', item)"
        >
          <el-row class="item">
            <el-col :span="4">
              <h2>{{ item.ano }}</h2>
            </el-col>
            <el-col :span="15">
              <h2>{{ item.mes }}</h2>
            </el-col>
            <el-col :span="5" class="text-right">
              <slot name="actions" v-bind:selected="item" v-if="showActions">
                <i
                  class="el-icon-arrow-right"
                  :style="`font-size: 16px; font-weight: bold; color: ${estilo.aplicacao.corPrimariaAplicacao}`"
                ></i>
              </slot>
            </el-col>
          </el-row>
        </li>
      </ul>
    </el-row>
    <el-row v-if="showMoreButton" class="text-center">
      <el-button class="load-more"  :style="estiloCarregar" @click="getMonthHistory(prev)" style="padding: 18px 60px">
        <div class="load-more-body">
          <svg-icone :url="icon" :style="`fill:${estilo.aplicacao.corPrimariaAplicacao}`"/>
          &nbsp;CARREGAR MAIS {{ monthsPerPage }} MESES
        </div>
      </el-button>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { urlIcons } from '@/utils/ImageBucket'
export default {
  name: 'dateBlocksVertical',
  props: {
    monthHistory: {
      type: Array,
      default: () => []
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    showActions: {
      type: Boolean,
      default: true
    },
    showMoreButton: {
      type: Boolean,
      default: false
    },
    showBody: {
      type: Boolean,
      default: true
    },
    monthsPerPage: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      history: [],
      pagination: {
        startLabel: '',
        endLabel: '',
        firstMonth: '',
        lastMonth: ''
      },
      currentMonth: moment().format('YYYY-MM-DD')
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    estiloLinha () {
      return `background: ${this.estilo.aplicacao.corPrimariaAplicacao}0d`
    },
    next () {
      return moment(this.pagination.firstMonth).add(this.monthsPerPage, 'months').format('YYYY-MM-DD')
    },
    prev () {
      return moment(this.pagination.lastMonth).subtract(1, 'months').format('YYYY-MM-DD')
    },
    lastMonthGreaterThanCurrent () {
      let diffDates = moment(this.pagination.firstMonth).diff(this.currentMonth, 'months')
      return diffDates >= 0
    },
    estiloCarregar () {
      return {
        color: `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    icon () {
      return urlIcons('Dash_add')
    }
  },
  methods: {
    init () {
      if (this.monthHistory.length > 0) {
        this.history = this.monthHistory
        this.setPagination()
      }
      if (this.history.length === 0) {
        this.getMonthHistory()
      }
    },
    getMonthHistory (date) {
      let oldMonth = date || this.currentMonth
      if (this.showPagination && !this.showMoreButton) this.history = []
      for (let i = 0; i < this.monthsPerPage; i++) {
        this.history.push({
          ano: this.getYear(oldMonth),
          mes: this.formatMonth(oldMonth),
          mesDate: oldMonth
        })
        oldMonth = moment(oldMonth).subtract(1, 'months').format('YYYY-MM-DD')
      }
      this.setPagination()
    },
    getYear (date) {
      return moment(date).format('YYYY')
    },
    formatMonth (date) {
      let month = moment(date).locale('pt-br').format('MMMM').toString()
      return month[0].toUpperCase() + month.slice(1)
    },
    setPagination () {
      this.clearPagination()
      this.pagination.startLabel = this.history[0].mes + ' ' + this.history[0].ano
      this.pagination.endLabel = this.history[this.history.length - 1].mes + ' ' + this.history[this.history.length - 1].ano
      this.pagination.firstMonth = this.history[0].mesDate
      this.pagination.lastMonth = this.history[this.history.length - 1].mesDate
    },
    clearPagination () {
      this.pagination = {
        startLabel: '',
        endLabel: '',
        firstMonth: '',
        lastMonth: ''
      }
    }
  },
  created () {
    this.init()
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Sharp:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=swap');
</style>
<style scoped lang="less">
.func-listagens {
  li {
    margin-bottom: 10px;
    border-radius: 6px;
  }
  h2 {
    letter-spacing: 0px;
    font-weight: 600;
    color: #333333;
    font-size: 16px;
  }
  .item {
    padding: 15px;
    margin-bottom: 0px;
    cursor: pointer;
  }
}
.load-more {
  border: none;
  border-radius: 10px;
  font-size: 14px;
  line-height: 19px;
  padding: 20px 15px;
  font-family: 'Open Sans';
  white-space: normal;
  background-color: rgba(0,111,185,0.05);
  &:hover {
    background-color: rgba(0,111,185,0.1);
  }
  .load-more-body {
    z-index: 10;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  svg {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
}
</style>
